import { createTypes } from 'redux-create-types';
import { fromType, } from 'kreighter';

const namespace = 'forumAttachments';

export const forumAttachmentsActions = createTypes([
    'createAttachment',
    'changeAttachmentStatus',
    'changeAttachmentProgress',
    'deleteAttachment',
    'deleteAllDraftAttachment',
    'deleteAllPostAttachment',
    'attachAttachmentToPost',
    'setAttachmentCorrectValue',
], namespace);

export const forumAttachmentsActionsCreators = {
    createAttachment: fromType(forumAttachmentsActions.createAttachment, ['id', 'title', 'url', 'fileType', 'status', 'postId', 'image']),
    changeAttachmentStatus: fromType(forumAttachmentsActions.changeAttachmentStatus, ['id', 'status']),
    changeAttachmentProgress: fromType(forumAttachmentsActions.changeAttachmentStatus, ['id', 'progress']),
    setAttachmentCorrectValue: fromType(forumAttachmentsActions.setAttachmentCorrectValue, ['id', 'newId', 'url', 'title', 'image']),
    attachAttachmentToPost: fromType(forumAttachmentsActions.changeAttachmentStatus, ['id', 'postId']),
    deleteAttachment: fromType(forumAttachmentsActions.deleteAttachment, ['id']),
    deleteAllPostAttachment: fromType(forumAttachmentsActions.deleteAllPostAttachment, ['postId']),
    deleteAllDraftAttachment: fromType(forumAttachmentsActions.deleteAllDraftAttachment, []),
}